import { Emphasis, MedicalHoItemCategory } from '@/modules/surgicalEvent';

export type RuleGender = 'ANY' | 'MALE' | 'FEMALE';
export type AgeBucket =
  | 'ANY'
  | 'A_0_7'
  | 'A_7_14'
  | 'A_14_18'
  | 'A_18_40'
  | 'A_40_65'
  | 'A_65_PLUS';

/**
 * Suggestion-catalog category. Mirrors the backend {@code MhoSuggestionCategory}
 * enum: every {@link MedicalHoItemCategory} value except BILLING (not surfaced
 * in scratch consultation), plus ALLERGIES (persisted through its own aggregate
 * but shares the same catalog UX).
 */
export type MhoCategory =
  | Exclude<MedicalHoItemCategory, MedicalHoItemCategory.BILLING>
  | 'ALLERGIES';

export type MhoSuggestionRule = { gender: RuleGender; ageBucket: AgeBucket };

export type MhoSuggestion = {
  id: number;
  category: MhoCategory;
  qcode?: string;
  code?: string;
  snomedCode?: string;
  freeTextLabel?: string;
  isCustom: boolean;
  defaultEmphasis: Emphasis;
  orderIndex: number;
  rules: MhoSuggestionRule[];
};

export type MhoSuggestionCreateRequest = {
  category: MhoCategory;
  qcode?: string;
  code?: string;
  snomedCode?: string;
  freeTextLabel?: string;
  defaultEmphasis: Emphasis;
  rules: MhoSuggestionRule[];
};

export type MhoSuggestionEmphasisUpdateRequest = { defaultEmphasis: Emphasis };
export type MhoSuggestionReorderRequest = {
  category: MhoCategory;
  orderedIds: number[];
};
export type MhoSuggestionResetRequest = {
  category: MhoCategory;
  includeCustom: boolean;
};

export const ALL_GENDER_OPTIONS: RuleGender[] = ['ANY', 'MALE', 'FEMALE'];
export const ALL_AGE_BUCKET_OPTIONS: AgeBucket[] = [
  'ANY',
  'A_0_7',
  'A_7_14',
  'A_14_18',
  'A_18_40',
  'A_40_65',
  'A_65_PLUS'
];
